export const EVIROMENT = "development_tas";
// export const EVIROMENT = "development";
// export const EVIROMENT = "releases";
